module.exports = __webpack_public_path__ + "img/facebook-yellow.e5fdba3d.svg";